module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Header'), _vm._v(" "), _c('div', {
    staticClass: "notFound"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../../static/img/magnifying-glass.svg"),
      "alt": "logo de uma lupa preta"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Você esta perdido?")]), _vm._v(" "), _c('h4', [_vm._v("A página que você procura não existe.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/biomanager/"
    }
  }, [_vm._v("Ir para Home.")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8739bda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/screens/404.vue
// module id = 269
// module chunks = 0